import { initI18n, getLocale } from '@tencent/iegsp-common/i18n';
import messages from '@intlify/unplugin-vue-i18n/messages';

initI18n(messages);

if (getLocale() === 'zh-CN') {
  document.title = '供应商门户';
}
